import { takeEvery, put, call, select } from "redux-saga/effects";

import {
  getMaintenanceEvents,
  getAllDataCenters,
  createMaintenanceEvent,
  updateMaintenanceEvent,
  deleteMaintenanceEvent,
 } from './maintenanceEvent.api';
import { types as maintenanceEventTypes, actions as maintenanceEventActions } from './maintenanceEvent.index';
import { actions as uiActions }     from '../ui/ui.index';
import { actions as errorActions }  from '../error/error.index';
import { actions as toastActions }  from '../toast/toast.index';


export function* fetchMaintenanceEvents() {
  try {
    let response =  yield call(getMaintenanceEvents);
    let payload  =  response.data.payload;

    yield put(maintenanceEventActions.setMaintenanceEvents(payload));
    const current_rows = payload.maintenance_windows.filter((item) => {
      if (new Date(item.end_date) > new Date()){
        return item;
      }
    });
    yield put(maintenanceEventActions.setActiveMaintenanceEvents(current_rows));
    yield put(uiActions.setRefreshTime());
    yield put(maintenanceEventActions.setMaintenanceEventLoading(false));
  }
  catch(error) {
    // handle ui effects
    const message      =  `Unable to check for Maintenance Events: ${error}`;
    const toastOptions =  {type: 'error', autoClose: false};
    yield put(toastActions.createToast(message, toastOptions));
    yield put(maintenanceEventActions.setMaintenanceEventLoading(true));

    // send error report
    const entireState = yield select();
    yield put(errorActions.raiseError({error, entireState}));
  }
}

export function* submitCreateMaintenanceEvent(action) {
  try{
    // extract relevant variables
    const payload =  action.payload;
    const response = yield call(createMaintenanceEvent, payload);
    yield put(maintenanceEventActions.requestMaintenanceEvents());
    yield put(maintenanceEventActions.setMaintenanceEventLoading(false));
    yield put(toastActions.createToast('Maintenance Event Created Successfully!', {type: 'success'}))
  }
  catch (error) {
    const message      =  `There was an issue creating the Maintenance Event. Please try again.`;
    const toastOptions =  {type: 'error', autoClose: false};
    yield put(toastActions.createToast(message, toastOptions));
  }
}

export function* submitUpdateMaintenanceEvent(action) {
  try{
    // extract relevant variables
    const payload =  action.payload;
    const response = yield call(updateMaintenanceEvent, payload);
    yield put(maintenanceEventActions.requestMaintenanceEvents());
    yield put(maintenanceEventActions.setMaintenanceEventLoading(false));
    yield put(toastActions.createToast('Maintenance Event Updated Successfully!', {type: 'success'}))
  }
  catch (error) {
    const message      =  `There was an issue updating the Maintenance Event. Please try again.`;
    const toastOptions =  {type: 'error', autoClose: false};
    yield put(toastActions.createToast(message, toastOptions));
  }
}

export function* submitDeleteMaintenanceEvent(action) {
  try{
    // extract relevant variables
    const payload =  action.payload;
    const response = yield call(deleteMaintenanceEvent, payload);
    yield put(maintenanceEventActions.requestMaintenanceEvents());
    yield put(maintenanceEventActions.setMaintenanceEventLoading(false));
    yield put(toastActions.createToast('Maintenance Event deleted Successfully!', {type: 'success'}))
  }
  catch (error) {
    const message      =  `There was an issue deleting the Maintenance Event. Please try again.`;
    const toastOptions =  {type: 'error', autoClose: false};
    yield put(toastActions.createToast(message, toastOptions));
  }
}

export function* fetchAllDataCenters(action){
  try {
    let response =  yield call(getAllDataCenters);
    let payload  =  response.data.payload.data;

    yield put(maintenanceEventActions.setAllDataCenters(payload));
    yield put(maintenanceEventActions.setMaintenanceEventLoading(false));
  }
  catch(error) {
    // handle ui effects
    const message      =  `Unable to check for All Data Centers: ${error}`;
    const toastOptions =  {type: 'error', autoClose: false};
    yield put(toastActions.createToast(message, toastOptions));
    yield put(maintenanceEventActions.setMaintenanceEventLoading(true));

    // send error report
    const entireState = yield select();
    yield put(errorActions.raiseError({error, entireState}));
  }
}

// watcher saga
export default function maintenanceWindowsSagas() {
  return [
    takeEvery(maintenanceEventTypes.REQUEST_MAINTENANCE_EVENTS, fetchMaintenanceEvents),
    takeEvery(maintenanceEventTypes.SUBMIT_CREATE_MAINTENANCE_EVENT, submitCreateMaintenanceEvent),
    takeEvery(maintenanceEventTypes.SUBMIT_UPDATE_MAINTENANCE_EVENT, submitUpdateMaintenanceEvent),
    takeEvery(maintenanceEventTypes.SUBMIT_DELETE_MAINTENANCE_EVENT, submitDeleteMaintenanceEvent),
    takeEvery(maintenanceEventTypes.REQUEST_ALL_DATA_CENTERS, fetchAllDataCenters),
  ];
}
